import React from 'react';

const Tracking = (props: any) => (
  <React.Fragment>
    <div className={props.classes.rowValues}>
      <h4>UTM / Trackeamento</h4>

      <div className='content__values'>
        <div className='value'>
          <div className='value__title'>Source</div>
          {props.invoice.cart && props.invoice.cart.utm_source ? props.invoice.cart.utm_source : '-'}
        </div>

        <div className='value'>
          <div className='value__title'>Campaign</div>
          {props.invoice.cart && props.invoice.cart.utm_campaign ? props.invoice.cart.utm_campaign : '-'}
        </div>

        <div className='value'>
          <div className='value__title'>Media</div>
          {props.invoice.cart && props.invoice.cart.utm_medium ? props.invoice.cart.utm_medium : '-'}
        </div>

        <div className='value'>
          <div className='value__title'>Content</div>
          {props.invoice.cart && props.invoice.cart.utm_content ? props.invoice.cart.utm_content : '-'}
        </div>

        <div className='value'>
          <div className='value__title'>Tracker</div>
          {props.invoice.cart && props.invoice.cart.tracker ? props.invoice.cart.tracker : '-'}
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default Tracking;
